import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';


interface IVMPlansAndProceduresProps{
    id: string
}

export const VMPlansAndProcedures: React.FC<IVMPlansAndProceduresProps> = ({id}) =>{
    const navigate = useNavigate();
    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
    <Box
        display={'flex'}
        flexDirection={smDown? 'column' : 'row'}
        width={'100%'}
    >
        <Box
           display={'flex'}
           flexDirection={'column'}
           alignItems={smDown? 'center' :  'start'}
           width={smDown? '100%' : '50%'}
           padding={1}
        >
            <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registos Legais</Typography>

            {/* <Button variant={isButtonActive(`/information_dam/${id}/training_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/training_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de treinamento</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/operation_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/operation_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de operação</Typography>
            </Button> */}

            <Button variant={isButtonActive(`/information_dam/${id}/maintenance_planning`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/maintenance_planning`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Planejamento das manutenções</Typography>
            </Button>
            
            <Button variant={isButtonActive(`/information_dam/${id}/monitoring_instrumentation_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/monitoring_instrumentation_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de monitoramento e instrumentação</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/dam_safety_inspections_planning`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/dam_safety_inspections_planning`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Planejamento das inspeções de segurança da barragem</Typography>
            </Button>

            {/* <Button variant={isButtonActive(`/information_dam/${id}/equipment_manuals_test_calibration_schedules`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/equipment_manuals_test_calibration_schedules`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Manuais dos equipamentos com cronogramas de testes e calibração</Typography>
            </Button> */}

            
        </Box>
        <Divider orientation={smDown? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
        <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={smDown? 'center' :  'start'}
            width={smDown? '100%' : '50%'}
            padding={1}
        >
            {/* <Typography variant='h6' color={theme.palette.primary.main} padding={0} marginLeft={1}>Informações Adicionais</Typography>
            <Button variant={isButtonActive(`/information_dam/${id}/hse_geotechsustainability_policy`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/hse_geotechsustainability_policy`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Política de Saúde e segurança ocupacional, gestão geotécnica e sustentabilidade</Typography>
            </Button>
            
            <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_structures_management`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_structures_management`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Padrão de gestão de estruturas geotécnicas</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/professional_training_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/professional_training_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de capacitação dos profissionais</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/risk_management_procedure`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risk_management_procedure`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Procedimento de gestão de risco</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/document_control_procedure`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/document_control_procedure`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Procedimento de controle de documentos</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/current_legislation`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/current_legislation`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Legislação vigente</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/change_management_procedure`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/change_management_procedure`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Procedimento de gestão de mudanças</Typography>
            </Button>
            
            <Button variant={isButtonActive(`/information_dam/${id}/quality_management_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/quality_management_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de gestão da qualidade</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/inspection_action_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/inspection_action_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de ação da inspeção</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_resources_relation`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_resources_relation`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relação dos recursos da geotecnia</Typography>
            </Button> */}
        </Box>
      </Box>
    );
};